const CLARITY_PROJECT_ID = 'miyw6vzhwm';

let clarityScriptPromise = null;

function isBrowser() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}

function loadScript(id, src) {
    if (!isBrowser()) return Promise.resolve();

    const existing = document.getElementById(id);
    if (existing) {
        if (existing.dataset.loaded === 'true') {
            return Promise.resolve();
        }
        return new Promise((resolve, reject) => {
            existing.addEventListener('load', () => resolve(), {once: true});
            existing.addEventListener('error', reject, {once: true});
        });
    }

    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.id = id;
        script.async = true;
        script.src = src;
        script.onload = () => {
            script.dataset.loaded = 'true';
            resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
    });
}

function ensureClarityQueue() {
    if (!isBrowser()) return;
    window.clarity = window.clarity || function (...args) {
        (window.clarity.q = window.clarity.q || []).push(args);
    };
}

export function loadClarity() {
    if (!isBrowser() || clarityScriptPromise) {
        return clarityScriptPromise || Promise.resolve();
    }

    ensureClarityQueue();
    clarityScriptPromise = loadScript(
        'clarity-script',
        `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`,
    ).catch((error) => {
        clarityScriptPromise = null;
        console.error('Failed to load Clarity', error);
    });

    return clarityScriptPromise;
}

export function scheduleClarityLoad() {
    if (!isBrowser()) return;

    const load = () => {
        void loadClarity();
    };

    if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(load, {timeout: 3000});
        return;
    }

    window.setTimeout(load, 1500);
}
